import {useState, useEffect} from 'react';

export default ({
    id,
    timestamp
}) => {
    const [time, setTime] = useState(Date.now() - timestamp);

    const format = (_time) => {
        const hours = Math.floor(_time / (60 * 60 * 1e3));

        if(hours >= 12) {
            const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                  date = new Date(timestamp);

            return `${date.getDate()} ${months[date.getMonth()]}, ${date.toLocaleTimeString([], {hour: '2-digit', minute: '2-digit', hour12: true})}`;
        } else {
            if(hours < 1) {
                const minutes = Math.floor((_time - (hours * 60 * 60 * 1e3)) / (60e3));

                if(minutes < 1)
                    return 'just now';

                return `${minutes} min ago`;
            }
            
            return `${hours} hours ago`;
        }
    }

    useEffect(() => {
        if(typeof window.notifications_timers === 'undefined')
            window.notifications_timers = {};

        if(time < (12 * 60 * 60 * 1e3)) {
            window.notifications_timers[id.toString()] = setTimeout(() => {
                setTime(Date.now() - timestamp)
            }, 500);
        }

        return () => clearTimeout(window.notifications_timers[id.toString()]);
    }, [time]);

    return format(time);
}